import getEnv from "@/utils/utils";

export const ADMIN_ROLES = getEnv("VITE_APP_KEYCLOAK_ADMIN_ROLES")
  ?.split(",")
  .map((role: string) => role.trim()) || ["benefits-team"];

export const INTERNAL_USER_ROLE =
  getEnv("VITE_APP_KEYCLOAK_INTERNAL_USER_ROLE") || "knx-internal-user";
